<template>
  <v-layout wrap class="card" style="min-height: 85px">
    <v-flex pa-2 align-self-center>
      <v-layout justify-between align-center direction="row">
        <v-flex xs5>
          <div class="primary--text mb-1 font-weight-bold mt-0 pl-5" style="word-break: break-all">
            {{ item.adminid }}
          </div>
        </v-flex>
        <v-flex v-if="!item.is_connect" xs5 text-xs-center>
          <v-btn
            v-if="$store.state.userid == item.adminid"
            round
            color="primary"
            class="px-5 py-3"
            @click="$emit('connectLineNotifyApprover', item)"
          >
            กดเพื่อเชื่อมต่อไลน์
          </v-btn>
          <span v-else style="color: red">ยังไม่ได้เชื่อมต่อไลน์</span>
        </v-flex>
        <v-flex v-else-if="item.is_connect" xs5 text-xs-center>
          <span style="color: green">เชื่อมต่อไลน์เรียบร้อยแล้ว</span>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-btn
            v-if="item.is_connect"
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="$emit('deleteApprover', item.adminid)"
          >
            <em class="fa fa-trash middle" />
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  props: ['item'],
  data() {
    return {}
  },
  computed: {
    notificationMessage() {
      try {
        const intents = JSON.parse(this.item.a_val)

        return intents[0][0].text
      } catch (error) {
        return '-'
      }
    }
  },
  async mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #ff706b;
  margin: 15px auto 0;
  border-radius: 10px 10px;
  overflow: hidden;
  p {
    color: #333;
  }
}

.notification-message {
  border-top: 1px solid #ddd;
  background-color: #f5f5f5;
  .message {
    border-radius: 6px;
    border: 1px solid #ddd;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/CardLineNotify.vue